import { render, staticRenderFns } from "./PlaceList.vue?vue&type=template&id=3e7ffdd4"
import script from "./PlaceList.vue?vue&type=script&lang=js"
export * from "./PlaceList.vue?vue&type=script&lang=js"
import style0 from "./PlaceList.vue?vue&type=style&index=0&id=3e7ffdd4&prod&media=screen&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports